// extracted by mini-css-extract-plugin
export default {"uploadTitle":"styles_uploadTitle__zj6oi","normal":"styles_normal__VUX8M","normalList":"styles_normalList__UpDIT"};